<div class="kt-portlet lum-c-adjustment-entry-form">
  <div class="kt-portlet__head align-items-center">
    <div class="kt-portlet__head-label">
      <span class="kt-portlet__head-icon">
        <i class="fas fa-chart-line"></i>
      </span>
      <div class="d-flex justify-content-between">
        <h3 class="kt-portlet__head-title">Inventory Stocks</h3>
      </div>
    </div>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
      *ngIf="isModal"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="kt-portlet__body">
    <mat-tab-group>
      <mat-tab label="General">
        <div class="adjustment-wrapper">
          <fieldset class="rfq-form">
            <div class="form-group" *ngIf="isModal && !rfq && currentRfq">
              <div class="sku-product-name">
                [{{ currentRfq.internal_sku }}] {{ currentRfq.product_name }}
              </div>
            </div>

            <div class="row" *ngIf="!isModal">
              <div class="col-sm-3" *ngIf="ftLocationBins">
                <div class="form-group">
                  <label>&nbsp;</label>
                  <select [(ngModel)]="mode" class="form-control">
                    <option value="sku">SKU</option>
                    <option value="keyword">Keyword Search</option>
                    <option value="location">Location</option>
                    <option value="sales-order">Sales Order</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-9">
                <div class="form-group" *ngIf="mode === 'sku'">
                  <label for="">{{
                    ftLocationBins ? 'Select SKU' : 'Select SKU'
                  }}</label>
                  <ng-select
                    [items]="rfq$ | async"
                    [multiple]="false"
                    [trackByFn]="trackByFn"
                    [clearable]="ftLocationBins"
                    [loading]="rfqLoading$ | async"
                    [typeahead]="rfqInput$"
                    name="rfqProduct"
                    (change)="ftLocationBins ? newSetRfq() : setRfq()"
                    [(ngModel)]="rfq"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span *ngIf="item && item.id">
                        [{{ item.internal_sku }}] {{ item.product_name }}
                      </span>
                      <span *ngIf="item.is_discontinued == 1">
                        - <b class="text-warning"> DISCONTINUED</b></span
                      >
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <span *ngIf="item && item.id">
                        [{{ item.internal_sku }}] {{ item.product_name }}
                      </span>
                      <span *ngIf="item.is_discontinued == 1">
                        - <b class="text-warning"> DISCONTINUED</b></span
                      >
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-group" *ngIf="mode === 'keyword'">
                  <label for="">{{
                    ftLocationBins ? 'Select SKU' : 'Select SKU'
                  }}</label>
                  <ng-select
                    [items]="rfq$ | async"
                    [multiple]="false"
                    [trackByFn]="trackByFn"
                    [clearable]="ftLocationBins"
                    [loading]="rfqLoading$ | async"
                    [typeahead]="keywordInput$"
                    name="rfqProduct"
                    (change)="ftLocationBins ? newSetRfq() : setRfq()"
                    [(ngModel)]="rfq"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span *ngIf="item && item.id">
                        [{{ item.internal_sku }}] {{ item.product_name }}
                      </span>
                      <span *ngIf="item.is_discontinued == 1">
                        - <b class="text-warning"> DISCONTINUED</b></span
                      >
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <span *ngIf="item && item.id">
                        [{{ item.internal_sku }}] {{ item.product_name }}
                      </span>
                      <span *ngIf="item.is_discontinued == 1">
                        - <b class="text-warning"> DISCONTINUED</b></span
                      >
                    </ng-template>
                  </ng-select>
                </div>
                <div
                  class="form-group"
                  *ngIf="ftLocationBins && mode === 'location'"
                >
                  <label for="">Select location</label>
                  <ng-select
                    [items]="location$ | async"
                    bindValue="id"
                    [typeahead]="locationInput$"
                    [loading]="locationLoading"
                    (change)="updateLocation($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item?.location_name }} ({{
                        item.parent_id === 0
                          ? 'GENERAL'
                          : item?.parent?.location_name
                      }})
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item?.location_name }} ({{
                        item.parent_id === 0
                          ? 'GENERAL'
                          : item?.parent?.location_name
                      }})
                    </ng-template>
                  </ng-select>
                </div>

                <div
                  class="form-group"
                  *ngIf="ftLocationBins && mode === 'sales-order'"
                >
                  <label for=""
                    >Select Order Number
                    <small>supports <b>onhand transactions</b> only</small></label
                  >
                  <ng-select
                    [items]="salesOrders$ | async"
                    bindValue="id"
                    [typeahead]="orderNumberInput$"
                    [loading]="salesOrderLoading"
                    (change)="updateSalesOrder($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      {{ item?.orderNumber }} ({{ item.orderStatus }})
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item?.orderNumber }} ({{ item.orderStatus }})
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>

            <div *ngIf="mode === 'sku' || mode === 'keyword'">
              <div class="mb-3" *ngIf="rfq">
                <div class="sku-product-name">
                  [{{ rfq.internal_sku }}]
                  {{ rfq.product_name }}
                </div>

                <div
                  class="overflow-auto"
                  *ngIf="
                    (ftLocationBins && rfq?.location_stocks.length) ||
                    !ftLocationBins
                  "
                >
                  <!-- NEW TABLE -->
                  <table
                    class="table table-striped inventory-stocks-table"
                    *ngIf="ftLocationBins"
                  >
                    <thead>
                      <tr>
                        <th>Warehouse</th>
                        <th>Incoming Qty</th>
                        <th>Onhand Qty</th>
                        <th>Pending Qty</th>
                        <th *ngIf="!ftLocationBins">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let entry of filterValidLocations(rfq.location_stocks);
                          let i = index
                        "
                      >
                        <td>
                          {{
                            entry.warehouse
                              ? entry.warehouse?.location_name
                              : 'GENERAL'
                          }}
                        </td>
                        <td>
                          {{ entry.qty_incoming || 0 | decimalPlaces }}
                          {{ getBaseUom(rfq?.unit_of_measures) }}
                        </td>
                        <td>
                          {{ entry.qty_onhand || 0 | decimalPlaces }}
                          {{ getBaseUom(rfq?.unit_of_measures) }}
                        </td>
                        <td>
                          {{ entry.qty_pending || 0 | decimalPlaces }}
                          {{ getBaseUom(rfq?.unit_of_measures) }}
                        </td>
                        <td class="text-right" *ngIf="!ftLocationBins">
                          <span
                            *ngIf="
                              entry.warehouse &&
                              entry.warehouse.id &&
                              stockEntryListOmit(entry.warehouse.id)?.length
                            "
                          >
                            <button
                              class="subtle-text"
                              mat-button
                              [matMenuTriggerFor]="updateStockWarehouse"
                            >
                              Move warehouse
                              <i class="fa fa-caret-down ml-2"></i>
                            </button>
                            <mat-menu
                              #updateStockWarehouse="matMenu"
                              xPosition="before"
                            >
                              <button
                                mat-menu-item
                                *ngFor="
                                  let warehouse of stockEntryListOmit(
                                    entry.warehouse.id
                                  )
                                "
                                (click)="
                                  newStockWarehouseChange(entry, warehouse.id)
                                "
                              >
                                {{ warehouse?.location_name }}
                              </button>
                            </mat-menu>

                            <span
                              class="ml-4 mr-4"
                              *ngIf="entry.stock_locations?.length"
                            >
                              <i class="fas fa-trash text-muted"></i>
                            </span>
                            <a
                              *ngIf="!entry.stock_locations?.length"
                              href="javascript:;"
                              (click)="newRemoveEntry(entry)"
                              title="Remove entry"
                              class="ml-4 mr-4"
                            >
                              <i class="fas fa-trash text-danger"></i>
                            </a>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- OLD TABLE -->
                  <table
                    class="table table-striped inventory-stocks-table"
                    *ngIf="!ftLocationBins && rfq"
                  >
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Warehouse</th>
                        <th>Incoming Qty</th>
                        <th>Onhand Qty</th>
                        <th>Pending Qty</th>
                        <th>Unit</th>
                        <th width="300">Stock Locations</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let entry of rfqEntries; let i = index">
                        <td>
                          {{ entry.rfq.internal_sku }}
                        </td>
                        <td>
                          <select
                            class="form-control"
                            name="wh{{ i + 1 }}"
                            (change)="stockWarehouseChange(entry, i)"
                            [(ngModel)]="entry.stock.warehouse_id"
                          >
                            <option *ngFor="let w of warehouses" [value]="w.id">
                              {{ w?.location_name }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">
                                {{ entry.stock.qty_incoming || 0 | decimalPlaces }}
                                {{ getBaseUom(entry?.rfq?.unit_of_measures) }}
                              </span>
                            </div>
                            <input
                              type="number"
                              class="form-control text-right"
                              name="{{'incoming' + i}"
                              [(ngModel)]="entry.stock.adj_incoming"
                              [readOnly]="entry.stock.warehouse_id === 0"
                            />
                          </div>
                        </td>
                        <td>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">
                                {{ entry.stock.qty_onhand || 0 | decimalPlaces }}
                                {{ getBaseUom(entry?.rfq?.unit_of_measures) }}
                              </span>
                            </div>
                            <input
                              type="number"
                              class="form-control text-right"
                              name="{{'onhand' + i}"
                              [(ngModel)]="entry.stock.adj_onhand"
                              [readOnly]="entry.stock.warehouse_id === 0"
                            />
                          </div>
                        </td>
                        <td>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">
                                {{ entry.stock.qty_pending || 0 | decimalPlaces }}
                                {{ getBaseUom(entry?.rfq?.unit_of_measures) }}
                              </span>
                            </div>
                            <input
                              type="number"
                              class="form-control text-right"
                              name="{{'pending' + i}"
                              [(ngModel)]="entry.stock.adj_pending"
                              [readOnly]="entry.stock.warehouse_id === 0"
                            />
                          </div>
                        </td>
                        <td>
                          <ng-select
                            [items]="entry?.rfq?.unit_of_measures"
                            [(ngModel)]="entry.stock.adjusted_uom_id"
                            bindValue="id"
                            bindLabel="name"
                            [name]="'adjusted_uom_id' + i"
                            [multiple]="false"
                            [clearable]="false"
                            class="uom"
                          >
                          </ng-select>
                        </td>
                        <td>
                          <div
                            *ngFor="
                              let location of entry.stock.stock_locations;
                              let idx = index
                            "
                            class="location-pill"
                          >
                            <div>
                              {{ location?.location_name }}
                            </div>
                            <button
                              (click)="
                                deleteRfqLocation(
                                  entry,
                                  location.id,
                                  idx,
                                  location.pivot?.lot_id
                                )
                              "
                            >
                              <i class="fa fa-times"></i>
                            </button>
                          </div>
                          <a
                            href="javascript:;"
                            (click)="addStockLocation(entry)"
                            title="Add stock locations"
                          >
                            <i class="fas fa-plus"></i>Add
                          </a>
                        </td>
                        <td>
                          <div *ngIf="entry.stock?.stock_locations?.length">
                            <i class="fas fa-trash text-muted"></i>
                          </div>
                          <a
                            *ngIf="!entry.stock?.stock_locations?.length"
                            href="javascript:;"
                            (click)="
                              removeSkuProductVariantStockEntry(entry.stock, i)
                            "
                            title="Remove entry"
                          >
                            <i class="fas fa-trash text-danger"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <button
                  class="subtle-text"
                  mat-stroked-button
                  [matMenuTriggerFor]="newWarehouse"
                  [disabled]="!stockEntryList()?.length"
                  *ngIf="ftLocationBins"
                >
                  + Add New Warehouse Stock Entry
                  <i class="fa fa-caret-down ml-2"></i>
                </button>
                <mat-menu #newWarehouse="matMenu">
                  <button
                    mat-menu-item
                    *ngFor="let warehouse of stockEntryList()"
                    (click)="newCreateStockEntry(warehouse.id)"
                  >
                    {{ warehouse?.location_name }}
                  </button>
                </mat-menu>
              </div>

              <div *ngIf="ftLocationBins && rfq">
                <div class="mb-4 overflow-auto">
                  <table class="table table-striped location-table mb-3">
                    <thead>
                      <tr>
                        <th>Location</th>
                        <th>Picking</th>
                        <th>Warehouse</th>
                        <th>Current Quantity</th>
                        <th width="200px">Quantity</th>
                        <th>Unit</th>
                        <th *ngIf="ftLotTracking">Lot Number</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container
                        *ngFor="
                          let entry of filterValidLocations(rfq.location_stocks);
                          let i = index
                        "
                      >
                        <tr
                          *ngFor="
                            let location of entry.stock_locations;
                            let idx = index
                          "
                        >
                          <td>{{ location?.location_name }}</td>
                          <td>
                            <i
                              *ngIf="location?.is_pick_location"
                              class="fa fa-check-circle"
                              style="color: green; font-size: 14px"
                            ></i>
                          </td>
                          <td>
                            {{
                              getWarehouseName(location.parent_id)?.location_name
                            }}
                          </td>

                          <td>
                            <span>
                              {{
                                location.pivot?.onhand_quantity || 0 | decimalPlaces
                              }}
                              {{ getBaseUom(rfq?.unit_of_measures) }}
                            </span>
                          </td>
                          <td>
                            <input
                              type="number"
                              class="form-control text-right"
                              [name]="'onhand' + i"
                              [(ngModel)]="location.adjustmentQuantity"
                              lumDecimalLimit
                            />
                          </td>
                          <td>
                            <ng-select
                              [items]="rfq?.unit_of_measures"
                              [(ngModel)]="location.adjusted_uom_id"
                              bindValue="id"
                              bindLabel="name"
                              [name]="'adjusted_uom_id' + i"
                              [multiple]="false"
                              [clearable]="false"
                              class="uom"
                            >
                            </ng-select>
                          </td>
                          <td *ngIf="ftLotTracking">
                            {{ getLot(rfq?.lots, location.pivot?.lot_id) }}
                          </td>
                          <td style="text-align: right">
                            <a
                              *ngIf="
                                !location.pivot ||
                                !location.pivot.onhand_quantity ||
                                location.pivot.onhand_quantity <= 0
                              "
                              href="javascript:;"
                              (click)="
                                newDeleteLocation(
                                  entry,
                                  location.id,
                                  location.pivot?.lot_id
                                )
                              "
                              title="Remove entry"
                            >
                              <i class="fas fa-trash text-danger"></i>
                            </a>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
                <div
                  ngbDropdown
                  class="dropdown lum-c-adjustment-entry-form-dropdown--wrapper"
                  *ngIf="ftLocationBins"
                >
                  <button
                    class="btn btn-default btn-sm dropdown-toggle"
                    ngbDropdownToggle
                  >
                    <i class="fas fa-plus"></i>
                    Add Location
                    <i class="fa fa-caret-down ml-2"></i>
                  </button>
                  <ul
                    ngbDropdownMenu
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li
                      *ngFor="
                        let entry of filterValidLocations(rfq.location_stocks)
                      "
                    >
                      <a
                        class="dropdown-item action-item"
                        (click)="newAddLocation(entry.warehouse.id)"
                      >
                        {{ entry.warehouse?.location_name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="t-footer" *ngIf="rfq">
                <div class="my-2">
                  <b>NOTE: </b> To update inventory quantities, enter adjustment
                  quantities to add or subtract. Use <b>(-)</b> negative values to
                  subtract quantities. Leave empty or put (0) to exclude quantity
                  updates.
                </div>
                <button
                  class="btn btn-primary mr-3"
                  type="button"
                  (click)="ftLocationBins ? newAddAdjustments() : addAdjustments()"
                >
                  <i class="fas fa-plus"></i> Add to Adjustment Entries
                </button>

                <button
                  class="btn btn-default"
                  type="button"
                  (click)="addNewRow()"
                  *ngIf="!ftLocationBins"
                >
                  <i class="fas fa-plus"></i> Add New Warehouse Stock Entry
                  <small>[ use this to add quantities to new warehouse ]</small>
                </button>
              </div>
            </div>

            <div *ngIf="mode === 'location'">
              <div class="overflow-auto">
                <div
                  class="sku-product-name overflow-auto"
                  *ngIf="selectedLocation"
                >
                  Location: {{ selectedLocation?.location_name }}
                  <i
                    *ngIf="selectedLocation?.is_pick_location"
                    class="fa fa-check-circle check-icon"
                  ></i>
                </div>
                <h3
                  *ngIf="
                    selectedLocation && !locationSkus.length && !loadingLocationSkus
                  "
                >
                  No SKUs at this location
                </h3>
                <div
                  class="spinner-border text-primary"
                  role="status"
                  *ngIf="loadingLocationSkus"
                >
                  <span class="sr-only">Loading...</span>
                </div>
                <table
                  class="table table-striped sku-table"
                  *ngIf="
                    locationSkus.length && selectedLocation && !loadingLocationSkus
                  "
                >
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Warehouse</th>
                      <th>Location</th>
                      <th>Current Quantity</th>
                      <th width="200px">Quantity</th>
                      <th>Unit</th>
                      <th *ngIf="ftLotTracking">Lot Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container
                      *ngFor="let sku of locationSkus; let skuIndex = index"
                    >
                      <ng-container
                        *ngFor="
                          let entry of filterValidLocations(sku.location_stocks);
                          let entryIndex = index
                        "
                      >
                        <tr
                          *ngFor="
                            let location of entry.stock_locations;
                            let i = index
                          "
                        >
                          <td> [{{ sku.internal_sku }}] {{ sku.product_name }} </td>
                          <td>
                            {{ entry.warehouse?.location_name }}
                          </td>

                          <td>
                            <cnc-picklist-location
                              [pickingLocation]="location.is_pick_location"
                            ></cnc-picklist-location
                            >{{ selectedLocation?.location_name }}
                          </td>
                          <td>
                            <span>
                              {{
                                location?.pivot.onhand_quantity || 0 | decimalPlaces
                              }}
                              {{ getBaseUom(sku?.unit_of_measures) }}
                              <!--  Sum up every active_picklist_items available_quantity -->
                              <pick-list-total
                                [picklistItems]="sku?.active_picklist_items"
                              ></pick-list-total>
                            </span>
                          </td>
                          <td>
                            <input
                              type="number"
                              class="form-control text-right"
                              name="{{'oncoming' + skuIndex + entryIndex + i }"
                              [(ngModel)]="location.adjustmentQuantity"
                              lumDecimalLimit
                            />
                          </td>
                          <td>
                            <ng-select
                              [items]="sku?.unit_of_measures"
                              [(ngModel)]="location.adjusted_uom_id"
                              bindValue="id"
                              bindLabel="name"
                              [name]="'adjusted_uom_id' + skuIndex + entryIndex + i"
                              [multiple]="false"
                              [clearable]="false"
                              class="uom"
                            >
                            </ng-select>
                          </td>
                          <td *ngIf="ftLotTracking">
                            {{ getLot(sku?.lots, location.pivot?.lot_id) }}
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>

              <div class="t-footer" *ngIf="selectedLocation && locationSkus.length">
                <div class="my-2">
                  <b>NOTE: </b> To update inventory quantities, enter adjustment
                  quantities to add or subtract. Use <b>(-)</b> negative values to
                  subtract quantities. Leave empty or put (0) to exclude quantity
                  updates.
                </div>
                <button
                  class="btn btn-primary mr-3"
                  type="button"
                  (click)="addLocationSkuAdjustment()"
                >
                  <i class="fas fa-plus"></i> Add to Adjustment Entries
                </button>
              </div>
            </div>

            <div *ngIf="mode === 'sales-order'">
              <div class="overflow-auto">
                <div
                  class="sku-product-name overflow-auto"
                  *ngIf="selectedSalesOrder"
                >
                  Sales Order:
                  <span
                    [ngClass]="{ 'text-danger': selectedSalesOrder.status < 0 }"
                  >
                    <b> {{ selectedSalesOrder.orderNumber }}</b>
                    ({{ selectedSalesOrder.orderStatus }})
                    <span *ngIf="selectedSalesOrder.status < 0"> DELETED </span>
                  </span>
                </div>
                <h4
                  class="text-warning my-5"
                  *ngIf="
                    selectedSalesOrder &&
                    !salesOrderLoading &&
                    !salesOrderAdjusmentEntries.length
                  "
                >
                  No onhand inventory transactions for this order
                </h4>
                <div
                  class="spinner-border text-center my-5 text-primary"
                  role="status"
                  *ngIf="salesOrderLoading"
                >
                  <span class="sr-only">Loading...</span>
                </div>
                <table
                  class="table table-striped sku-table"
                  *ngIf="salesOrderAdjusmentEntries.length"
                >
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Warehouse</th>
                      <th>Location</th>
                      <th>Current Quantity</th>
                      <th width="150px">Order Quantity</th>
                      <th width="150px">Quantity</th>
                      <th>Unit</th>
                      <th *ngIf="ftLotTracking">Lot Number</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let salesItem of salesOrderAdjusmentEntries;
                        let skuIndex = index
                      "
                    >
                      <td>[{{ salesItem.sku }}] {{ salesItem.name }}</td>
                      <td>
                        {{ salesItem.warehouse.location_name }}
                      </td>
                      <td>
                        {{ salesItem.location.location_name }}
                      </td>
                      <td>
                        <span>
                          {{ salesItem.currentQuantity | decimalPlaces }}
                          {{ salesItem.baseUom }}
                        </span>
                      </td>
                      <td>
                        <span>
                          {{ salesItem.quantity | decimalPlaces }}
                          {{ salesItem.baseUom }}
                        </span>
                      </td>
                      <td>
                        <input
                          type="number"
                          class="form-control text-right"
                          name="{{ 'oncoming' + skuIndex }}"
                          [(ngModel)]="salesItem.adjustmentQuantity"
                          lumDecimalLimit
                        />
                      </td>
                      <td>
                        {{ salesItem.baseUom }}
                      </td>
                      <td *ngIf="ftLotTracking">
                        {{ salesItem.lot?.lot_number }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="t-footer" *ngIf="selectedSalesOrder">
                <div class="my-2">
                  <b>NOTE: </b> To update inventory quantities, enter adjustment
                  quantities to add or subtract. Use <b>(-)</b> negative values to
                  subtract quantities. Leave empty or put (0) to exclude quantity
                  updates.
                </div>
                <button
                  class="btn btn-primary mr-3"
                  type="button"
                  (click)="addSalesOrderAdjustment()"
                >
                  <i class="fas fa-plus"></i> Add to Adjustment Entries
                </button>
              </div>
            </div>
          </fieldset>
          <div *ngIf="adjustmentEntries.length">
            <hr />
            <fieldset>
              <legend>SKU Adjustment Entries</legend>
              <div class="overflow-auto">
                <!-- OLD ADJUSTMENT TABLE -->
                <table class="table table-striped" *ngIf="!ftLocationBins">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Warehouse</th>
                      <th>Incoming Qty</th>
                      <th>Onhand Qty</th>
                      <th>Pending Qty</th>
                      <th>Unit</th>
                      <th>Stock Locations</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let entry of adjustmentEntries; let i = index">
                      <td>
                        {{ entry.sku }}
                      </td>
                      <td>
                        {{ entry.product_name }}
                      </td>
                      <td>
                        <select
                          class="form-control"
                          name="w{{ i + 1 }}"
                          [(ngModel)]="entry.warehouse_id"
                        >
                          <option *ngFor="let w of warehouses" [value]="w.id">
                            {{ w.location_name }}
                          </option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="number"
                          class="form-control text-right"
                          name="{{'incoming' + i}"
                          [(ngModel)]="entry.adj_incoming"
                          [readOnly]="entry.warehouse_id != 0 ? false : true"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          class="form-control text-right"
                          name="{{'onhand' + i}"
                          [(ngModel)]="entry.adj_onhand"
                          [readOnly]="entry.warehouse_id != 0 ? false : true"
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          class="form-control text-right"
                          name="{{'pending' + i}"
                          [(ngModel)]="entry.adj_pending"
                          [readOnly]="entry.warehouse_id != 0 ? false : true"
                        />
                      </td>
                      <td>
                        <ng-select
                          [items]="unitOfMeasures[entry.rfq_id]"
                          [(ngModel)]="entry.adjusted_uom_id"
                          bindValue="id"
                          bindLabel="name"
                          [name]="'adjusted_uom_id' + i"
                          [multiple]="false"
                          class="disable-clear-all"
                          [clearable]="false"
                          [searchable]="entry.warehouse_id != 0 ? false : true"
                        >
                        </ng-select>
                      </td>
                      <td>
                        <div
                          *ngFor="
                            let location of entry.stock_locations;
                            let idx = index
                          "
                          class="location-pill"
                        >
                          <div>
                            {{ location.location_name }}
                          </div>
                          <button
                            (click)="
                              deleteRfqLocation(
                                entry,
                                location.id,
                                idx,
                                location.pivot?.lot_id
                              )
                            "
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </td>
                      <td>
                        <a
                          href="javascript:;"
                          (click)="adjustmentEntries.splice(i, 1)"
                          title="Remove entry"
                        >
                          <i class="fas fa-times text-danger"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="7">
                        <span *ngIf="adjustmentEntries.length > 0">
                          <b>NOTE: </b> To update inventory quantities, enter
                          adjustment quantities to add or subtract. Use
                          <b>(-)</b> negative values to subtract quantities. Leave
                          empty or put (0) to exclude quantity updates.
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- NEW ADJUSTMENT TABLE -->
                <table class="table table-striped" *ngIf="ftLocationBins">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Warehouse</th>
                      <th>Stock Adjustments</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let entry of adjustmentEntries; let i = index">
                      <td>
                        {{ entry.sku }}
                      </td>
                      <td>
                        {{ entry.warehouse?.location_name }}
                      </td>
                      <td>
                        <div
                          *ngFor="
                            let location of entry.stock_locations;
                            let idx = index
                          "
                          class="location-pill"
                        >
                          <div>
                            {{ location.location_name }}
                          </div>
                          <div>
                            {{ location.adjustmentQuantity | decimalPlaces
                            }}<i>{{
                              getUomById(entry.rfq_id, location.adjusted_uom_id)
                            }}</i>
                          </div>
                          <div
                            *ngIf="
                              location.pivot && location.pivot.lot && ftLotTracking
                            "
                          >
                            {{ location.pivot?.lot?.lot_number }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <a
                          href="javascript:;"
                          (click)="adjustmentEntries.splice(i, 1)"
                          title="Remove entry"
                        >
                          <i class="fas fa-times text-danger"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="7">
                        <span *ngIf="adjustmentEntries.length > 0">
                          <b>NOTE: </b> To update inventory quantities, enter
                          adjustment quantities to add or subtract. Use
                          <b>(-)</b> negative values to subtract quantities. Leave
                          empty or put (0) to exclude quantity updates.
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="pt-3">
                <div class="form-group">
                  <label for="">Remarks</label>
                  <textarea
                    name="remarks"
                    rows="3"
                    class="form-control"
                    [(ngModel)]="adjustmentRemarks"
                  ></textarea>
                </div>

                <button
                  class="btn btn-primary"
                  type="button"
                  [disabled]="adjustmentEntries.length === 0 || loading"
                  (click)="postAdjustments()"
                  [ngClass]="{
                    'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                      loading,
                  }"
                >
                  <i class="fas fa-save"></i> Post Adjustment Entries
                </button>
              </div>
            </fieldset>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="QTY LOGS" *ngIf="rfq && isModal">
        <cnc-rfq-details-qty-logs [rfq]="rfq"></cnc-rfq-details-qty-logs>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
